import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router-dom'

import {
  createObjectDraftStepComponentMap,
  getCreateObjectStepById,
} from 'widgets/kyrgyzstan/create-object-wizard'

import type { CreateObjectDraftStepId } from 'features/kyrgyzstan/create-object'

import {
  CreateObjectStepId,
  editObjectSessionStore,
} from 'entities/kyrgyzstan/model'

interface EditObjectStepScreenProps {
  draftId: string | null
  parentPath: string
  stepId?: string
  getStepPath: (stepId: CreateObjectStepId) => string
}

export const EditObjectStepScreen = ({
  draftId,
  parentPath,
  stepId,
  getStepPath,
}: EditObjectStepScreenProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const activeStep = getCreateObjectStepById(stepId)
  const isForbiddenStep =
    activeStep?.id === CreateObjectStepId.ObjectType ||
    activeStep?.id === CreateObjectStepId.Confirmation

  if (!activeStep || isForbiddenStep || !draftId) {
    return (
      <Navigate
        to={parentPath}
        replace
      />
    )
  }

  const StepComponent =
    createObjectDraftStepComponentMap[activeStep.id as CreateObjectDraftStepId]

  if (!StepComponent) {
    return (
      <Navigate
        to={parentPath}
        replace
      />
    )
  }

  const handleBack = () => {
    navigate(parentPath)
  }

  const handleOpenStep = (nextStepId: CreateObjectStepId) => {
    editObjectSessionStore.markDirty()
    navigate(getStepPath(nextStepId))
  }

  const handleSave = () => {
    editObjectSessionStore.markDirty()
    navigate(parentPath, { replace: true })
  }

  return (
    <StepComponent
      layoutProps={{
        continueLabel: t(
          'kyrgyzstan_block.create_object.actions.update_information',
        ),
        onBack: handleBack,
      }}
      draftId={draftId}
      mode="edit"
      onNext={handleSave}
      onOpenStep={handleOpenStep}
    />
  )
}
